import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    repository = new CreateRepository()
    rankChanel = new Subject();
    signatoryChannel = new Subject();
    documentTypeChanel = new Subject();
    
    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchRank = async (query) => {
        this.rankChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchRank(query).then((result) => {
            this.rankChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.rankChanel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchSignatory = async (query) => {
        this.signatoryChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSignatoryOfficial(query).then((result) => {
            this.signatoryChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.signatoryChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchCreate = async (query) => {
        this.createChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchCreate(query).then((result) => {
            this.createChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.createChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchDocumentType = async (query) => {
        this.documentTypeChanel.next({status: apiResponse.LOADING})
        await this.repository.fetchDocumentType(query).then((result) => {
            this.documentTypeChanel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.documentTypeChanel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default CreateBloc